export const DASHBOARD_GET = 'DASHBOARD_GET';
export const UNREAD_PESAN_GET = 'UNREAD_PESAN_GET';
export const UNREAD_PESAN_UPDATE = 'UNREAD_PESAN_UPDATE';